import { render } from "./RatingsPopup.vue?vue&type=template&id=6600c42c&scoped=true"
import script from "./RatingsPopup.vue?vue&type=script&lang=js"
export * from "./RatingsPopup.vue?vue&type=script&lang=js"

import "./RatingsPopup.vue?vue&type=style&index=0&id=6600c42c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6600c42c"]])

export default __exports__